export const ApiEndpoints = {
  autor: {
    authorList: "api/authors",
    authorCreate: "api/author/store",
    authorEdit: "api/author/edit/",
    authorUpdate: "api/author/update",
    authorDelete: "api/author/delete",
  },

  filters: {
    List: "api/filters-data-fetch",
  },

  tags: {
    tagList: "api/tags",
    tagCreate: "api/tag/store",
    tagEdit: "api/tag/edit/",
    tagUpdate: "api/tag/update",
    tagDelete: "api/tag/delete",
  },

  infographics: {
    List: "api/infographics",
    Create: "api/infographic/store",
    Edit: "api/infographic/edit/",
    Update: "api/infographic/update/",
    Delete: "api/infographic/delete",
  },

  eguide: {
    List: "api/eguides",
    Create: "api/eguide/store",
    Edit: "api/eguide/edit/",
    Update: "api/eguide/update/",
    Delete: "api/eguide/delete",
  },

  whitepaper: {
    List: "api/whitepapers",
    Create: "api/whitepaper/store",
    Edit: "api/whitepaper/edit/",
    Update: "api/whitepaper/update/",
    Delete: "api/whitepaper/delete",
  },

  newsletter: {
    List: "api/newsletters",
    Create: "api/newsletter/store",
    Edit: "api/newsletter/edit/",
    Update: "api/newsletter/update/",
    Delete: "api/newsletter/delete",
  },

  pr: {
    List: "api/press-releases",
    Create: "api/press-release/store",
    Edit: "api/press-release/edit/",
    Update: "api/press-release/update/",
    Delete: "api/press-release/delete",
  },

  leadership: {
    List: "api/leaderships",
    Create: "api/leadership/store",
    Edit: "api/leadership/edit/",
    Update: "api/leadership/update/",
    Delete: "api/leadership/delete",
  },

  video: {
    List: "api/videos",
    Create: "api/video/store",
    Edit: "api/video/edit/",
    Update: "api/video/update/",
    Delete: "api/video/delete",
  },

  solution: {
    List: "api/solutions",
    Create: "api/solution/store",
    Edit: "api/solution/edit/",
    Update: "api/solution/update",
    Delete: "api/solution/delete",
  },

  specialty: {
    List: "api/specialties",
    Create: "api/specialty/store",
    Edit: "api/specialty/edit/",
    Update: "api/specialty/update",
    Delete: "api/specialty/delete",
  },

  provider: {
    List: "api/providers",
    Create: "api/provider/store",
    Edit: "api/provider/edit/",
    Update: "api/provider/update",
    Delete: "api/provider/delete",
  },

  adminBlogs: {
    blogList: "api/blogs",
    blogCreate: "api/blog/store",
    blogEdit: "api/blog/edit/",
    blogUpdate: "api/blog/update/",
    blogDelete: "api/blog/delete",
  },

  category: {
    categoryList: "api/blog-categories",
    categoryCreate: "api/blog-category/store",
    categoryEdit: "api/blog-category/edit/",
    categoryUpdate: "api/blog-category/update",
    categoryDelete: "api/blog-category/delete",
  },

  team: {
    List: "api/teams",
    Create: "api/team/store",
    Edit: "api/team/edit/",
    Update: "api/team/update/",
    Delete: "api/team/delete",
  },

  contact: {
    contactCreate: "api/contact/store",
    contactList: "api/contact/view",
  },



  seo: {
    seoList: "api/seo",
    seoCreate: "api/seo/store",
    seoEdit: "api/seo/edit/",
    seoUpdate: "api/seo/update",
    seoDelete: "api/seo/delete",
    seoByUrl: 'api/seo-by-url'
  },

  faq: {
    faqList: "api/faqs",
    faqCreate: "api/faq/store",
    faqEdit: "api/faq/edit/",
    faqUpdate: "api/faq/update",
    faqDelete: "api/faq/delete",
    faqByUrl: "api/faq-by-url",
  },

  sitemap: {
    view: "api/sitemap",
    update: "api/sitemap/update",
  },

  llmsManagement: {
    view: "api/llms-management",
    update: "api/llms-management/update",
  },

  robots: {
    view: "api/robots-txt",
    update: "api/robots-txt/update",
  },

  emailManagement: {
    List: "api/dynamic-emails",
    Create: "api/dynamic-email/store",
    Edit: "api/dynamic-email/edit/",
    Update: "api/dynamic-email/update",
    Delete: "api/dynamic-email/delete",
  },

  schemaManagement: {
    view: "api/schema-management",
    update: "api/schema-management/update",
  },

  globalSeo: {
    view: "api/global-seo",
    update: "api/global-seo/update",
  },

  caseStudy: {
    caseStudyList: "api/casestudys",
    caseStudyCreate: "api/casestudy/store",
    caseStudyEdit: "api/casestudy/edit/",
    caseStudyUpdate: "api/casestudy/update/",
    caseStudyDelete: "api/casestudy/delete",
  },

  news: {
    newsList: "api/medias",
    newsCreate: "api/media/store",
    newsEdit: "api/media/edit/",
    newsUpdate: "api/media/update/",
    newsDelete: "api/media/delete",
  },

  // career


  jobApplication: {
    List: "api/job/applications",
  },

  career: {
    careerCreate: "api/career/store",
    careerList: "api/careers",
  },

  job: {
    List: "api/jobs",
    Create: "api/job/store",
    Edit: "api/job/edit/",
    Update: "api/job/update",
    Delete: "api/job/delete",
  },
  loc: {
    List: "api/locations",
    Create: "api/location/store",
    Edit: "api/location/edit/",
    Update: "api/location/update",
    Delete: "api/location/delete",
  },
  exp: {
    List: "api/experiences",
    Create: "api/experience/store",
    Edit: "api/experience/edit/",
    Update: "api/experience/update",
    Delete: "api/experience/delete",
  },
  operation: {
    List: "api/departments",
    Create: "api/department/store",
    Edit: "api/department/edit/",
    Update: "api/department/update",
    Delete: "api/department/delete",
  },

  rbac: {
    myPermissions: "api/rbac/my-permissions",
    userList: "api/rbac/users", userCreate: "api/rbac/user/store", userEdit: "api/rbac/user/edit/", userUpdate: "api/rbac/user/update/", userDelete: "api/rbac/user/delete",
    roleList: "api/rbac/roles", roleCreate: "api/rbac/role/store", roleEdit: "api/rbac/role/edit/", roleUpdate: "api/rbac/role/update/", roleDelete: "api/rbac/role/delete",
    permissionList: "api/rbac/permissions", permissionCreate: "api/rbac/permission/store", permissionEdit: "api/rbac/permission/edit/", permissionUpdate: "api/rbac/permission/update/", permissionDelete: "api/rbac/permission/delete",
  },

  Dashboard: {
    List: "api/leads-count",
     monthlycount: "api/leads-count-filter", 
  },

  
};
